<mat-grid-list [cols]="12" rowHeight="125px">
  <mat-grid-tile colspan="3">
    <mat-form-field [style.width]="'96%'">
      <mat-label>Key Name</mat-label>
      <input matInput placeholder="Key Name" [formControl]="keyName" required />
    </mat-form-field>
  </mat-grid-tile>
  @if (expires.value) {
  <mat-grid-tile colspan="2">
    <mat-form-field [style.width]="'98%'">
      <mat-label>Select a date</mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="date">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </mat-grid-tile>
  <mat-grid-tile colspan="3">
    <div [style.width]="'98%'">
      <ngx-mat-timepicker-field [style.width]="'100%'" color="primary" [format]="12"
        [defaultTime]="time.value ?? '12:12 PM'" (timeChanged)="time.patchValue($event)"></ngx-mat-timepicker-field>
    </div>
  </mat-grid-tile>
  }
  <mat-grid-tile>
    <mat-checkbox class="rh-checkbox" [formControl]="expires">Key Expires?</mat-checkbox>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="rh-btn-container">
      <button class="rh-list-btn" mat-button (click)="createKey()" [disabled]="keyName.invalid">Create Key</button>
    </div>
  </mat-grid-tile>
</mat-grid-list>